<template>
  <div>
    <filtro-cadu v-model="valueData" @limparFiltro="limparFiltro()" @filtrar="filtrar()">
      <div slot="body" class="mx-5" style="height: 420px">
        <v-row>
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">
              FILTRAR MUNICÍPIOS IBGE
            </div>
          </v-col>
        </v-row>

        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="5">
              <validation-provider name="uf" mode="eager" rules="alpha" v-slot="{ errors }">
                <autocomplete-cadu
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="UF"
                  :items="listaUF.map(el => el.sigla)"
                  v-model="ufSelecionado"
                  @input="input => getMunicipios(input)"
                />
              </validation-provider>
            </v-col>
            <v-col cols="7">
              <validation-provider name="codIBGE" mode="eager" rules="numeric" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaCodigoIBGE"
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="Código IBGE"
                  v-model="codIBGESelecionado"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <validation-provider name="municipio" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="nomesMunicipios"
                  :errorMessage="errors[0]"
                  placeholder=""
                  title="Município"
                  v-model="municipioSelecionado"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
  </div>
</template>

<script>
/* eslint-disable */

import { ValidationProvider, ValidationObserver } from "vee-validate";

import Estado from "@/services/AreaAcao/Estado";
import ListaMunicipios from "@/services/Dominios/ListaMunicipios";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      valueData: this.value,
      nomesUF: [],
      listaUF: [],
      listaCodigoIBGE: [],
      nomesMunicipios: [],
      listaMunicipios: [],
      ufSelecionado: "",
      codIBGESelecionado: "",
      municipioSelecionado: "",
      idUF: null
    };
  },
  beforeMount() {
    this.getEstados();
  },
  methods: {
    async getEstados() {
      var estados = new Estado(localStorage.getItem("tokenBearer"), this.$appConfig.config.API);

      await estados
        .getEstados()
        .then(res => {
          res.data.forEach(item => {
            this.listaUF.push(item);
          });
        })
        .catch(err => {
          console.error(err);

          this.listaUF = [];
        });

        
    },
    async getMunicipios(codigo) {
      const estado = this.listaUF.find(estado => estado.sigla === codigo);
      const municipios = new ListaMunicipios(localStorage.getItem("tokenBearer"), this.$appConfig.config.API);

      var tipoPesquisaMunicipio = null;

      this.selectedUF = estado ? estado.id : null;

      this.nomesMunicipios = []
      this.listaCodIBGE = []
      this.listaMunicipios = []

      var municipiosNome = []
      var codigoIBGE = []
      var listaMunicipios = []

      this.selectedUF
        ? (tipoPesquisaMunicipio = municipios.getMunicipio(this.selectedUF))
        : (tipoPesquisaMunicipio = municipios.getAllMunicipios());

      await tipoPesquisaMunicipio
        .then(res => {
          res.data.forEach(item => {
            municipiosNome.push(item.nome);
            codigoIBGE.push(item.id);
            listaMunicipios.push(item);
          });
        })
        .catch(err => {
          console.error(err);

          this.nomesMunicipios = [];
          this.listaCodigoIBGE = [];
          this.listaMunicipios = [];
        });
      this.nomesMunicipios = municipiosNome
      this.listaCodigoIBGE = codigoIBGE
      this.listaMunicipios = listaMunicipios
        
    },
    limparFiltro() {
      this.ufSelecionado = "";
      this.codIBGESelecionado = "";
      this.municipioSelecionado = "";
    },
    filtrar() {
      let objUF = this.listaUF.find(item => item.sigla === this.ufSelecionado);

      let filtro = {
        uf: objUF != null ? objUF : "",
        codigo: this.codIBGESelecionado != null ? this.codIBGESelecionado : "",
        municipio: this.municipioSelecionado != null ? this.municipioSelecionado : ""
      };

      this.$emit("filtrar-municipios-ibge", filtro);
      this.valueData = false;
    }
  },
  watch: {
    valueData() {
      if (!this.valueData) {
        this.$emit("input", false);
      }
    },
    value() {
      this.valueData = this.value;
    }
  }
};
</script>

<style></style>
